.container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--skeleton-grey);
    /* Matches the min width of the lead page content + sidebar */
    min-width: 1224px; /* content = 800px, sidebar = 400px, content gap = 8px, side padding = 8px * 2 */
    gap: 8px;
}

.content-container {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 8px;
    /* If changing, update the min width above and in header.module.css */
    padding: 0 8px;
    box-sizing: border-box;
}

.sidebar-and-content-container-scroll {
    overflow: auto;
    margin-bottom: 8px;
}

.center-content-scroll-container {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
}
